// extracted by mini-css-extract-plugin
module.exports = {"root":"DropdownItem_root","isSelected":"DropdownItem_isSelected"};